import { call, put } from "redux-saga/effects";
import { fetchAssemblyGuideByArticleNumber } from "../requests/assemblyGuide";
import {
  startLoadingIndicator,
  stopLoadingIndicator,
} from "../../loadingIndicator/loadingIndicatorActions";
import {
  fetchAsssemblyGuideByArticleNumberFailure,
  fetchAsssemblyGuideByArticleNumberSuccess,
} from "../../assemblyGuide/assemblyGuideAction";

export function* handleAssemblyGuide({ payload: { articleNumber, lang } }) {
  try {
    yield put(startLoadingIndicator());

    const response = yield call(fetchAssemblyGuideByArticleNumber, {
      articleNumber,
      lang,
    });
    const { products } = parseAssemblyGuideData(response);
    if (!products) {
      yield put(
        fetchAsssemblyGuideByArticleNumberFailure({
          error: { message: "" },
        })
      );
    } else {
      yield put(fetchAsssemblyGuideByArticleNumberSuccess({ products }));
    }
    yield put(stopLoadingIndicator());
  } catch (error) {
    console.error(`handleTrackAssemblyGuide error = ${error}`);
    yield put(fetchAsssemblyGuideByArticleNumberFailure({ error }));
    yield put(stopLoadingIndicator());
  }
}

const parseAssemblyGuideData = (response) => {
  return {
    products: response?.data?.productcatalog?.products,
  };
};
